import events from "../../events/EventsObservable";
import { MESSAGE_EVENTS, MESSAGE_TYPES } from "../../error/errorMessages";
import { EVENTS } from "../../events/baseEvents";
import { UIMESSAGES_EVENTS } from "./UIMessages";
import IMadmaxMessage from "./IMadmaxMessage";
import { translate } from "../../translations/translations";
import { BASE_ELEMENT_IDS } from "../BaseDOM";
import { ACTION_EVENTS } from "../UserAction";
import { createHiddenMessage } from "../../vendor/erebos";

// import QRCode from 'qrcode';
const QRCode = require("qrcode");
import SystemConfig, { CONFIG_PARAMS } from "../../system/SystemConfig";

/**
 * @class
 */
class MadmaxMessage implements IMadmaxMessage {
  id: number;
  priority: number;
  isActive: boolean;
  isNewStyle: boolean = true;

  private _type: string;
  zIndex: number;
  title: string;
  content: string[];
  code: string | number;
  config: SystemConfig;
  private _buttons: Record<string, any>;
  private _lang: string;
  private _visible: boolean;
  private _onClose: () => void;

  private _icons = require.context(
    "../../../assets/img/inline/ui/icons",
    true,
    /\.svg$/
  );

  wrapper: HTMLElement;
  contentElement: HTMLElement;
  buttonsElement: HTMLElement;

  constructor(
    title: string = null,
    content: string | string[],
    buttons: Record<string, any>,
    lang: string,
    type: string,
    zIndex: number = 0,
    config: SystemConfig,
    code?: string | number
  ) {
    this.config = config;
    this.id = Date.now() + Math.random();
    this._type = type ? type : MESSAGE_TYPES.INFO;
    this.code = code;

    this.setPriority();
    this.isActive = false;

    this.zIndex = zIndex ? zIndex : 100;
    this.title = title;

    if (this.isNewStyle && (!this.title || this.title === "")) {
      this.title =
        this._type.charAt(0).toUpperCase() + this._type.slice(1).toLowerCase();
    }
    this.content = Array.isArray(content) ? content : [content];

    this._buttons = buttons;
    // this._buttonsEvents = {};

    this._lang = lang;

    this._onClose = () => {};
  }

  // setOn(key, func) {
  //     this._buttonsEvents[key] = func;
  // }

  /**
   * @protected
   */ create() {
    this.wrapper = document.createElement("div");
    this.wrapper.classList.add("mx-message-box", "mx-message-" + this._type);
    if (this.isNewStyle) {
      this.wrapper.style.position = "relative";
    }

    if (!this.isNewStyle) {
      let title = document.createElement("div");
      title.classList.add("mx-message-title");
      title.innerHTML = this.title;
      this.wrapper.appendChild(title);
    } else {
      if (this.title) {
        const header = document.createElement("div");
        header.classList.add("mx-message-header");

        const icon = document.createElement("div");
        icon.classList.add("mx-message-icon");
        icon.innerHTML = this._getTypeIcon();
        header.appendChild(icon);

        const titleElement = document.createElement("h3");
        titleElement.classList.add("mx-message-title");
        titleElement.innerHTML = this.title;
        header.appendChild(titleElement);

        this.wrapper.appendChild(header);
      } else {
        const icon = document.createElement("div");
        icon.classList.add("mx-message-icon");
        icon.style.margin = "0 auto 16px auto";
        icon.innerHTML = this._getTypeIcon();
        this.wrapper.appendChild(icon);
      }
    }

    this.contentElement = document.createElement("div");
    this.contentElement.classList.add("mx-message-content");

    for (const text of this.content) {
      const res = document.createElement("div");
      res.innerHTML = text;
      this.contentElement.appendChild(res);
    }
    this.wrapper.appendChild(this.contentElement);

    if (
      this._buttons &&
      typeof this._buttons === "object" &&
      Object.keys(this._buttons).length > 0
    ) {
      const buttonCount = Object.keys(this._buttons).length;
      this.buttonsElement = document.createElement("div");
      this.buttonsElement.classList.add("mx-message-buttons");
      this.wrapper.appendChild(this.buttonsElement);
      if (buttonCount >= 3) {
        this.buttonsElement.classList.add("mx-vertical-buttons");
      }
    }

    for (let key in this._buttons) {
      this.addButton(this._buttons[key], key);
    }

    this._visible = true;
    this.hide();
  }

  private _getTypeIcon(): string {
    let iconName: string;
    let iconColor: string;

    switch (this._type) {
      case MESSAGE_TYPES.ERROR:
        iconName = "error.svg";
        iconColor = "#dc3545";
        break;
      case MESSAGE_TYPES.COOLDOWN:
        iconName = "cooldown.svg";
        iconColor = "#7c3aed";
        break;
      case MESSAGE_TYPES.WARNING:
        iconName = "warning.svg";
        iconColor = "#ffc107";
        break;
      case MESSAGE_TYPES.YES_NO:
        iconName = "question.svg";
        iconColor = "#6c757d";
        break;
      case MESSAGE_TYPES.OK:
        iconName = "ok.svg";
        iconColor = "#198754";
        break;
      case MESSAGE_TYPES.INFO:
        iconName = "info.svg";
        iconColor = "#0dcaf0";
        break;
      case MESSAGE_TYPES.FREESPINS:
        iconName = "freespins.svg";
        iconColor = "#cc66ff";
        break;
      default:
        iconName = "info.svg";
        iconColor = "#0dcaf0";
    }

    if (this.code && (this.code + "").length > 0) {
      console.log(`MadmaxMessage: code is set to ${this.code}`);

      const erebosData = this.config.getMany(
        CONFIG_PARAMS.SESSION_ID,
        CONFIG_PARAMS.CASINO_ID,
        CONFIG_PARAMS.GAME_ID,
        CONFIG_PARAMS.CURRENCY
      );

      const hiddenMessage = createHiddenMessage(
        JSON.stringify({
          code: this.code,
          ...erebosData,
        }),
        30
      );

      window.onresize = () => {
        const dpr = window.devicePixelRatio || 1;
        this.wrapper.style.backgroundSize = `${hiddenMessage.size / dpr}px ${
          hiddenMessage.size / dpr
        }px`;
      };

      this.wrapper.classList.add("mx-message-qr");

      this.wrapper.style.backgroundAttachment = "fixed";
      const dpr = window.devicePixelRatio || 1;
      this.wrapper.style.backgroundSize = `${hiddenMessage.size / dpr}px ${
        hiddenMessage.size / dpr
      }px`;
      this.wrapper.style.backgroundRepeat = "repeat";
      this.wrapper.style.backgroundImage = `url(${hiddenMessage.data})`;

      const imgId = `qr-${this.id}`;
      const placeholder = `<img id="${imgId}" style="border-radius: 100%; box-shadow: 0 1px 3px rgba(0,0,0,0.1);" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" alt="${this._type} icon" />`;

      QRCode.toDataURL(
        this.code.toString() +
          `;${erebosData[CONFIG_PARAMS.SESSION_ID]};${
            erebosData[CONFIG_PARAMS.CASINO_ID]
          }`,
        {
          errorCorrectionLevel: "M",
          margin: 7,
          scale: 2,
          color: {
            dark: iconColor,
            light: "#00000000",
          },
        }
      )
        .then((url) => {
          const img = document.getElementById(imgId) as HTMLImageElement;
          if (img) {
            img.src = url;
          }
        })
        .catch((e) => {
          console.warn(`Failed to generate QR code`, e);
        });

      return placeholder;
    }

    const imgId = `icon-${this.id}`;
    return `<img id="${imgId}" width="35" height="35" style="box-shadow: 0 1px 3px rgba(0,0,0,0.1);" src="${this._icons(
      `./${iconName}`
    )}" alt="${this._type} icon" />`;
  }

  setPriority() {
    switch (this._type) {
      case MESSAGE_TYPES.ERROR:
        this.priority = 80;
        break;
      case MESSAGE_TYPES.COOLDOWN:
        this.priority = 69;
        break;
      case MESSAGE_TYPES.WARNING:
        this.priority = 60;
        break;
      case MESSAGE_TYPES.YES_NO:
        this.priority = 50;
        break;
      case MESSAGE_TYPES.OK:
        this.priority = 40;
        break;
      case MESSAGE_TYPES.INFO:
        this.priority = 30;
        break;
      case MESSAGE_TYPES.FREESPINS:
        this.priority = 20;
        break;
      default:
        this.priority = 10;
        break;
    }
  }

  getElement() {
    return this.wrapper;
  }

  async _dispatchEvent(eventName) {
    switch (eventName) {
      case MESSAGE_EVENTS.MESSAGE_CLOSE_GAME:
        events.dispatch(EVENTS.CLOSE_GAME);
        break;

      case MESSAGE_EVENTS.MESSAGE_CLOSE:
        this._close();
        break;

      case MESSAGE_EVENTS.SWITCH_TO_FREESPINS:
        await events.dispatch(MESSAGE_EVENTS.SWITCH_TO_FREESPINS);
        this._close();
        break;

      case MESSAGE_EVENTS.SWITCH_TO_REAL:
        await events.dispatch(MESSAGE_EVENTS.SWITCH_TO_REAL);
        this._close();
        break;
      case MESSAGE_EVENTS.OPEN_HISTORY:
        const external = this.config.get(CONFIG_PARAMS.URL_IGT_HISTORY);
        if (!external) {
          this._close();
        }
        await events.dispatch(ACTION_EVENTS.ACTION_HISTORY_OPEN, {
          internal: !external,
          url: external,
        });
        break;
    }
  }

  setOnClose(f) {
    this._onClose = f;
  }

  unsetOnClose() {
    this._onClose = () => {};
    return this;
  }

  _close() {
    this.closeMessage();
    this._onClose();
  }

  openMessage() {
    if (this.isActive) return;

    this.isActive = true;
    events.dispatch(UIMESSAGES_EVENTS.UIMESSAGE_OPEN, this);
  }

  show() {
    $(this.wrapper).show();
    this._visible = true;
  }

  closeMessage() {
    if (!this.isActive) return;

    this.isActive = false;
    events.dispatch(UIMESSAGES_EVENTS.UIMESSAGE_CLOSE);
  }

  hide() {
    $(this.wrapper).hide();
    this._visible = false;
  }

  isMessageOpened() {
    return this._visible;
  }

  setContent(content: string | string[]) {
    this.content = Array.isArray(content) ? content : [content];
    this.contentElement.innerHTML = "";

    for (const text of this.content) {
      const res = document.createElement("div");
      res.innerHTML = text;
      this.contentElement.appendChild(res);
    }
  }

  destroy() {
    this.wrapper.remove();
    events.dispatch(UIMESSAGES_EVENTS.UIMESSAGE_DESTROY, this);
  }

  addButton(btn: any, key) {
    let button = document.createElement("button");
    button.classList.add("mx-message-button", "mx-message-button-" + key);

    this.buttonsElement.appendChild(button);
    let txt;
    if (this.isNewStyle) {
      if (btn.msg && btn.msg["$translate"]) {
        txt = translate(btn.msg["$translate"], this._lang);
        txt = txt
          .split(" ")
          .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          )
          .join(" ");
      } else {
        txt =
          btn.msg && btn.msg[this._lang]
            ? btn.msg[this._lang]
            : key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();
      }
    } else {
      if (btn.msg && btn.msg["$translate"]) {
        txt = translate(btn.msg["$translate"], this._lang);
      } else {
        txt =
          btn.msg && btn.msg[this._lang]
            ? btn.msg[this._lang]
            : key.toUpperCase();
      }
    }

    button.innerHTML = txt;

    let eventsArray = Array.isArray(btn.event) ? btn.event : [btn.event];

    if (eventsArray.length) {
      $(button).on("click", (e) => {
        for (let eventName of eventsArray) {
          this._dispatchEvent(eventName);
        }
      });
    } else {
      $(button).on("click", (e) => this._close());
    }
  }

  hideButtons() {
    for (let i = 0; i < this.buttonsElement.children.length; i++) {
      $(this.buttonsElement.children.item(i)).hide();
    }
  }

  showButtons() {
    for (let i = 0; i < this.buttonsElement.children.length; i++) {
      $(this.buttonsElement.children.item(i)).show();
    }
  }
}

export default MadmaxMessage;
